/**
 * User: Faris
 * Date: 5/24/13
 * Time: 3:24 PM
 */

requirejs.config({
  baseUrl: '/library/js/',
  waitSeconds: 0,
  paths: {
    backbone: '../../bower_components/backbone/backbone',
    underscore: '../../bower_components/underscore/underscore',
    'dustjs-linkedin': '../../bower_components/dustjs-linkedin/dist/dust-full.min',
    'dustjs-linkedin-helpers': '../../bower_components/dustjs-linkedin-helpers/lib/dust-helpers',
    'es5-shim': '../../bower_components/es5-shim/es5-shim',
    greensock: '../../bower_components/greensock/src/uncompressed/TweenMax',
    'greensock-lite': '../../bower_components/greensock/src/uncompressed/TweenLite',
    hammerjs: '../../bower_components/hammerjs/hammer',
    jquery: '../../bower_components/jquery/dist/jquery',
    'jquery.browser': '../../bower_components/jquery.browser/dist/jquery.browser',
    'jquery.serializeJSON': '../../bower_components/jquery.serializeJSON/jquery.serializejson',
    'jquery-maskedinput': '../../bower_components/jquery-maskedinput/dist/jquery.maskedinput',
    'jquery-mousewheel': '../../bower_components/jquery-mousewheel/jquery.mousewheel',
    'jquery-placeholder': '../../bower_components/jquery-placeholder/jquery.placeholder',
    'malihu-custom-scrollbar-plugin': '../../bower_components/malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar',
    modernizr: '../../bower_components/modernizr/modernizr',
    parsleyjs: '../../bower_components/parsleyjs/dist/parsley',
    requirejs: '../../bower_components/requirejs/require',
    respond: '../../bower_components/respond/dest/respond.src',
    select2: '../../bower_components/select2/select2',
    lodash: '../../bower_components/lodash/dist/lodash.compat',
    'greensock-scrollto': './libs/ScrollToPlugin.min',
    async: '../../bower_components/requirejs-plugins/src/async',
    depend: '../../bower_components/requirejs-plugins/src/depend',
    font: '../../bower_components/requirejs-plugins/src/font',
    goog: '../../bower_components/requirejs-plugins/src/goog',
    image: '../../bower_components/requirejs-plugins/src/image',
    json: '../../bower_components/requirejs-plugins/src/json',
    mdown: '../../bower_components/requirejs-plugins/src/mdown',
    noext: '../../bower_components/requirejs-plugins/src/noext',
    propertyParser: '../../bower_components/requirejs-plugins/src/propertyParser',
    'Markdown.Converter': '../../bower_components/requirejs-plugins/lib/Markdown.Converter',
    text: '../../bower_components/requirejs-plugins/lib/text',
    'jquery-ui': '../../bower_components/jquery-ui/jquery-ui',
    'jquery-ui-core': '../../bower_components/jquery-ui/ui/core',
    'jquery-ui-datepicker': '../../bower_components/jquery-ui/ui/datepicker',
    spin: '../../bower_components/spin.js/spin',
    'event-shim': '../../bower_components/event-shim.js/event-shim'
  },
  map: {
    '*': {
      underscore: 'lodash'
    },
    'jquery-ui-datepicker': {
      core: 'jquery-ui-core'
    }
  },
  shim: {
    backbone: [
      'jquery',
      'underscore'
    ],
    'dustjs-linkedin-helpers': [
      'dustjs-linkedin'
    ],
    'greensock-scrollto': [
      'greensock'
    ],
    'jquery-maskedinput': [
      'jquery'
    ],
    'jquery-mousewheel': [
      'jquery'
    ],
    'jquery-placeholder': [
      'jquery'
    ],
    'jquery.browser': [
      'jquery'
    ],
    'jquery.serializeJSON': [
      'jquery'
    ],
    'malihu-custom-scrollbar-plugin': [
      'jquery'
    ],
    parsleyjs: [
      'jquery'
    ],
    select2: [
      'jquery'
    ]
  },
  packages: [

  ]
});
define("config", function(){});

